export default class Parallax {
    constructor() {
        this.boxes = [];
        this.init();
    }

    init() {
        var self = this;
        // Store the window width
        var windowWidth = window.innerWidth;

        // Create an animation for each ease box. Each with a different timing.
        Array.prototype.forEach.call( document.querySelectorAll( '[data-parallax]' ), function( elem, i ) {
            var from = elem.getAttribute( 'data-parallax-from' );
            var fromPosition = elem.getAttribute( 'data-parallax-from-position' );
            var to = elem.getAttribute( 'data-parallax-to' );
            var toPosition = elem.getAttribute( 'data-parallax-to-position' );

            from = ( from !== null ) ? from : '-50px';
            to = ( to !== null ) ? to : '50px';

            fromPosition = ( fromPosition !== null ) ? fromPosition : 'bottom-top';
            toPosition = ( toPosition !== null ) ? toPosition : 'top-bottom';

            if ( elem.classList.contains( 'parallax--initialized' ) ) {
                return;
            } else {
                elem.classList.add( 'parallax--initialized' );
            }

            self.boxes.push(
                basicScroll.create( {
                    elem: elem,
                    from: fromPosition,
                    to: toPosition,
                    direct: true,
                    props: {
                        '--ty': {
                            from: from,
                            to: to,
                            direct: true
                        },
                        '--tx': {
                            from: '-25%',
                            to: '25%',
                            direct: true
                        },
                        '--skew': {
                            from: '25deg',
                            to: '-25deg',
                            direct: true
                        }
                    }
                }, {
                    enabled: true
                } )
            );
        } );

        self.boxes.forEach( function( box ) {
            setTimeout( function() {
                box.start();
            }, 50 );
        } );

        window.onresize = function() {
            if ( window.innerWidth != windowWidth ) {
                windowWidth = window.innerWidth;
                self.recalculate();
            }
        }
    }

    recalculate() {
        this.boxes.forEach( function( box ) {
            box.calculate();
        } );
    }
}